(() => {
 const root=document.querySelector('[data-member-benefits]');
 if(!root)return;
 root.classList.add('mb-has-js');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const motionButton=root.querySelector('[data-mb-motion]');
 let paused=false;
 function syncMotion(){
  root.dataset.motion=paused||reduced.matches?'paused':'running';
  motionButton.hidden=false;motionButton.disabled=reduced.matches;
  motionButton.setAttribute('aria-pressed',String(paused||reduced.matches));
  motionButton.querySelector('span').textContent=reduced.matches?'Motion reduced':paused?'Resume motion':'Pause motion';
 }
 motionButton.addEventListener('click',()=>{paused=!paused;syncMotion();});
 reduced.addEventListener('change',syncMotion);syncMotion();
 const groups=[];
 function measureGroup(group){
  if(!group.host.getClientRects().length)return;
  group.host.style.minHeight='';
  group.panels.forEach(panel=>{panel.style.visibility='hidden';panel.hidden=false;});
  const height=Math.ceil(group.host.getBoundingClientRect().height);
  group.panels.forEach((panel,index)=>{panel.hidden=index!==group.active;panel.style.visibility='';});
  if(height>0)group.host.style.minHeight=height+'px';
 }
 function measureAll(){groups.slice().reverse().forEach(measureGroup);}
 root.querySelectorAll('[data-mb-tabs]').forEach(wrapper=>{
  const list=wrapper.querySelector('[data-mb-tablist]');
  const host=wrapper.querySelector('[data-mb-panels]');
  const buttons=[...list.children].filter(el=>el.matches('[data-mb-tab]'));
  const panels=buttons.map(button=>root.querySelector('[id="'+button.dataset.mbTab+'"]'));
  if(panels.some(panel=>!panel))return;
  const group={host,buttons,panels,active:0};groups.push(group);
  list.hidden=false;list.setAttribute('role','tablist');host.classList.add('mb-panels-ready');
  function select(index,focus=false){
   group.active=index;
   buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
   if(focus)buttons[index].focus({preventScroll:true});
   requestAnimationFrame(measureAll);
  }
  buttons.forEach((button,index)=>{
   button.setAttribute('role','tab');button.setAttribute('aria-controls',panels[index].id);
   panels[index].setAttribute('role','tabpanel');panels[index].setAttribute('aria-labelledby',button.id);panels[index].tabIndex=0;
   button.addEventListener('click',()=>select(index));
   button.addEventListener('keydown',event=>{
    let next=index;
    if(event.key==='ArrowRight')next=(index+1)%buttons.length;
    else if(event.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=buttons.length-1;
    else return;
    event.preventDefault();select(next,true);
   });
  });select(0);
 });
 let resizeFrame=0;
 const nav=root.querySelector('.mb-nav');
 const sideNav=nav.cloneNode(true);
 sideNav.className='mb-side-nav';sideNav.hidden=true;
 sideNav.setAttribute('aria-label','Membership benefits sidebar');
 sideNav.querySelectorAll('a').forEach(link=>{
  const label=link.textContent.trim();
  link.setAttribute('aria-label',label);link.title=label;
  const text=document.createElement('span');text.textContent=label;
  [...link.childNodes].filter(node=>node.nodeType===Node.TEXT_NODE).forEach(node=>node.remove());
  link.append(text);
 });
 root.append(sideNav);
 const links=[...nav.querySelectorAll('a')];
 const sideLinks=[...sideNav.querySelectorAll('a')];
 const sections=links.map(link=>root.querySelector(link.getAttribute('href')));
 function updateHeader(){
  const header=document.querySelector('.site-header');
  const height=header?Math.ceil(header.getBoundingClientRect().height):84;
  root.style.setProperty('--mb-header-h',height+'px');
 }
 function markSection(){
  const height=parseFloat(getComputedStyle(root).getPropertyValue('--mb-header-h'))||84;
  const offset=height+24;let current=0;
  sections.forEach((section,index)=>{if(section.getBoundingClientRect().top<=offset+4)current=index;});
  [links,sideLinks].forEach(items=>items.forEach((link,index)=>{if(index===current)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');}));
  sideNav.hidden=innerWidth<=900||nav.getBoundingClientRect().bottom>height+12||root.getBoundingClientRect().bottom<=innerHeight;
 }
 let scrollFrame=0;window.addEventListener('scroll',()=>{if(scrollFrame)return;scrollFrame=requestAnimationFrame(()=>{markSection();scrollFrame=0;});},{passive:true});
 window.addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{updateHeader();measureAll();markSection();});});
 updateHeader();requestAnimationFrame(()=>{measureAll();markSection();});
 document.fonts?.ready.then(measureAll);
 if('IntersectionObserver' in window&&!reduced.matches){
  const targets=[...root.querySelectorAll('.mb-section')];
  let observer;
  try{
   observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('mb-reveal-pending');entry.target.classList.add('mb-revealed');observer.unobserve(entry.target);}}),{threshold:0.06});
   targets.forEach(target=>{if(target.getBoundingClientRect().top>innerHeight){target.classList.add('mb-reveal-pending');observer.observe(target);}});
   // The page remains readable even if an observer is present but never fires.
   setTimeout(()=>targets.forEach(target=>target.classList.remove('mb-reveal-pending')),8000);
  }catch{targets.forEach(target=>target.classList.remove('mb-reveal-pending'));observer?.disconnect();}
 }
})();
